/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { RegistrationVatConsistencyCouple } from './';
import {
    RegistrationVatConsistencyCoupleFromJSON,
    RegistrationVatConsistencyCoupleFromJSONTyped,
    RegistrationVatConsistencyCoupleToJSON,
} from './';
import type { RegistrationVatConsistencyStatus } from './';
import {
    RegistrationVatConsistencyStatusFromJSON,
    RegistrationVatConsistencyStatusFromJSONTyped,
    RegistrationVatConsistencyStatusToJSON,
} from './';

/**
 * 
 * @export
 * @interface ValidateRegistrationVatConsistencyResponse
 */
export interface ValidateRegistrationVatConsistencyResponse {
    /**
     * 
     * @type {RegistrationVatConsistencyStatus}
     * @memberof ValidateRegistrationVatConsistencyResponse
     */
    status: RegistrationVatConsistencyStatus;
    /**
     * 
     * @type {RegistrationVatConsistencyCouple}
     * @memberof ValidateRegistrationVatConsistencyResponse
     */
    suggestedCouple?: RegistrationVatConsistencyCouple;
}

/**
 * Check if a given object implements the ValidateRegistrationVatConsistencyResponse interface.
 */
export function instanceOfValidateRegistrationVatConsistencyResponse(value: object): value is ValidateRegistrationVatConsistencyResponse {
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function ValidateRegistrationVatConsistencyResponseFromJSON(json: any): ValidateRegistrationVatConsistencyResponse {
    return ValidateRegistrationVatConsistencyResponseFromJSONTyped(json, false);
}

export function ValidateRegistrationVatConsistencyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateRegistrationVatConsistencyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'status': RegistrationVatConsistencyStatusFromJSON(json['status']),
        'suggestedCouple': json['suggestedCouple'] == null ? undefined : RegistrationVatConsistencyCoupleFromJSON(json['suggestedCouple']),
    };
}

export function ValidateRegistrationVatConsistencyResponseToJSON(value?: ValidateRegistrationVatConsistencyResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'status': RegistrationVatConsistencyStatusToJSON(value['status']),
        'suggestedCouple': RegistrationVatConsistencyCoupleToJSON(value['suggestedCouple']),
    };
}

